import PropTypes from "prop-types";
import { Box } from "@mui/material";

const BGIcon = ({ Icon }) => {
  return (
    <Box sx={{ height: "100%", position: "relative" }}>
      <Icon
        sx={(theme) => ({
          position: "absolute",
          top: { xs: 50, sm: "300" },
          left: 16,
          fontSize: { xs: 200, sm: 500 },
          color: theme.palette.primary.verylight,
          opacity: 0.3,
        })}
      />
    </Box>
  );
};

BGIcon.propTypes = {
  Icon: PropTypes.instanceOf(Object),
};

export default BGIcon;
